import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { Github, Globe } from 'lucide-react';

const AboutContainer = styled.section`
  padding: 5rem 2rem;
  background: #0e0e10;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const AboutGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

const TextContent = styled.div``;

const SectionTitle = styled.h2`
  font-size: 3rem;
  margin-bottom: 1rem;
  background: linear-gradient(45deg, #39c0ed, #7a43e5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  color: #b0b0b0;
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 2rem;
`;

const AuthorCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 3rem;
  text-align: center;
  
  &:hover {
    border-color: rgba(57, 192, 237, 0.3);
  }
`;

const AuthorName = styled.h3`
  font-size: 2rem;
  margin-bottom: 0.5rem;
  color: #fff;
`;

const AuthorRole = styled.p`
  color: #39c0ed;
  font-size: 1.2rem;
  margin-bottom: 1rem;
`;

const AuthorBio = styled.p`
  color: #b0b0b0;
  line-height: 1.6;
  margin-bottom: 2rem;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

const SocialLink = styled(motion.a)`
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: all 0.3s;
  
  &:hover {
    background: linear-gradient(45deg, #39c0ed, #7a43e5);
    border-color: transparent;
    transform: translateY(-3px);
  }
`;

const About: React.FC = () => {
  return (
    <AboutContainer id="about">
      <Content>
        <AboutGrid>
          <TextContent>
            <SectionTitle>About Contact Manager</SectionTitle>
            <Description>
              Contact Manager was born from the need for a simple, yet powerful solution to manage 
              personal and professional contacts. In today's interconnected world, maintaining 
              relationships is crucial, and our app makes it effortless.
            </Description>
            <Description>
              Built with modern Android development practices, Contact Manager offers a seamless 
              experience with intuitive features that adapt to your workflow. Whether you're a 
              business professional, entrepreneur, or someone who values staying connected, 
              this app is designed for you.
            </Description>
            <Description>
              Our commitment to privacy means your data stays yours. With local storage options 
              and optional cloud backup, you have complete control over your information.
            </Description>
          </TextContent>
          
          <AuthorCard
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <AuthorName>Rolan</AuthorName>
            <AuthorRole>Developer & Creator</AuthorRole>
            <AuthorBio>
              Passionate software developer with a focus on creating intuitive and efficient 
              mobile applications. Dedicated to building tools that make everyday tasks simpler 
              and more enjoyable.
            </AuthorBio>
            <SocialLinks>
              <SocialLink
                href="https://rolan-rnr.netlify.app/"
                target="_blank"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <Globe size={24} />
              </SocialLink>
              <SocialLink
                href="https://github.com/Mrtracker-new"
                target="_blank"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <Github size={24} />
              </SocialLink>
            </SocialLinks>
          </AuthorCard>
        </AboutGrid>
      </Content>
    </AboutContainer>
  );
};

export default About;
